// here we add all base urls and keys

import { get_project_info_localStorage } from "src/DAL/localStorage/localStorage";
import { update_root_value } from "src/utils/domUtils";

// Base URLS
export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const api_key = process.env.REACT_APP_WEB_API_KEY;
export const socketBaseUri = process.env.REACT_APP_API_SOCKET_BASE_URL;
export const websiteUrl = process.env.REACT_APP_WEBSITE_URL;
const get_project_info = get_project_info_localStorage();
export const material_theme_palate = {
  lighter: "#d4bff2",
  light: "#ede7f6",
  main: "#1a93a9",
  dark: "#198BA8",
  darker: "#198BA8",
  contrastText: "#fff",
};

export const OwnerName = () => "Danielle";

export const ownerName = OwnerName() + "'s";
export const ownerCompleteName = OwnerName();

export const get_app_logo = () => {
  if (get_project_info && get_project_info.brand_logo) {
    return s3baseUrl + get_project_info.brand_logo;
  } else {
    return "";
  }
};

export const get_app_headers = () => {
  if (get_project_info && get_project_info.meta_title) {
    return {
      title: get_project_info.meta_title,
      description: get_project_info.meta_description,
      fav_icon: s3baseUrl + get_project_info.brand_favicon,
    };
  } else {
    return {
      title: "DANIELLE | Client",
      description: "DANIELLE | Client",
      fav_icon: "",
    };
  }
};

material_theme_palate.main = "#C19D60";
/* Main theme color */
update_root_value("--portal-theme-primary", "#C19D60");
update_root_value(
  "--portal-theme-primary-filter-color",
  "invert(69%) sepia(29%) saturate(570%) hue-rotate(359deg) brightness(88%) contrast(92%)"
);
update_root_value("--portal-theme-secondary", "rgb(255 218 0 / 8%)");
update_root_value("--text-primary-color", "white");
update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
/* Main theme color end */

/* Main background color*/
update_root_value("--background-primary-color", "black");
update_root_value("--background-secondary-color", "#1d1c1d");

/* Main background color end*/

/* Sidebar Properties */
update_root_value("--sidebars-text-color", "white");
update_root_value("--sidebars-active-color", "#C19D60");
update_root_value("--sidebars-hover-color", "#C19D60");
update_root_value("--sidebars-background-color", "#1d1c1d");
/* Sidebar Properties */

/* Popup / Popover properties  */
update_root_value("--popup-background-color", "#1d1c1d");
update_root_value("--popup-text-color", "white");
/* Popup / Popover properties end  */

/* Element properties */
update_root_value("--input-text-color", "#fff");
update_root_value("--input-placeholder-color", "#fff");
update_root_value("--input-background-primary", "#1d1c1d");
update_root_value("--input-background-secondary", "#1d1c1d");
update_root_value(" --icons-color-allover", "#C19D60");
/* Element properties ends*/

/* Button Properties */

update_root_value("--button-background-color", "#1c1c1c");
update_root_value("--button-text-color", "#C19D60");
update_root_value("--button-outlined-color", "#C19D60");
update_root_value("--button-hover-color", "#C19D60");

/* Button Properties ends*/

/* Audio Properties */
update_root_value("--audio-color", "rgb(56, 54, 54)");
/* Audio Properties ends*/

/* calendar Properties */
update_root_value("--calendar-selected-box", "#8b8b8b");
update_root_value("--datepicker-selected-color", "#fff");
/* calendar Properties ends*/
